// extracted by mini-css-extract-plugin
export var buttonContainer = "_66-1";
export var fontSizeSelect = "_66-3";
export var formatSelect = "_66-2";
export var formats = "_66-4";
export var hidden = "_66-5";
export var icon = "_66-6";
export var select = "_66-0";